import { Controller } from 'react-hook-form';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import { RowProps } from './types';
import Textarea from '../textarea/textarea';
import IconCopy from '../icons/copy-two';

import styles from './transaction.module.css';

let timeout: NodeJS.Timeout;

export default function SidepanelTextareaRow({
  title,
  name,
  value,
  control,
  enableEdit,
  placeholder,
  children,
  borderless = false,
  error,
  disabled,
  tabIndex,
  copyEnabled,
  copyValue,
  maxLength,
  fieldValue,
  setFieldValue,
  clearErrors,
}: RowProps): React.JSX.Element {
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    setCopyIsSuccess(true);
    copy(copyValue as string);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  let content;

  if (enableEdit) {
    content = (
      <Controller
        name={name}
        control={control}
        rules={{ required: false }}
        defaultValue={value}
        render={({ field }) => (
          <Textarea
            title={title}
            name={name}
            value={fieldValue || field.value}
            onChange={(e) => {
              if (error && clearErrors) {
                clearErrors([name]);
              }

              if (setFieldValue) {
                clearTimeout(timeout);

                setFieldValue(e.target.value);

                if (e.target.value) {
                  timeout = setTimeout(() => {
                    field.onChange(e.target.value);
                  }, 400);
                } else if (!e.target.value.length) {
                  clearTimeout(timeout);
                  field.onChange('');
                }
              } else {
                field.onChange(e);
              }
            }}
            placeholder={placeholder as string}
            className={`${borderless ? 'borderless' : ''} `}
            tabIndex={tabIndex}
            error={error}
            disabled={disabled}
            maxLength={maxLength}
          />
        )}
      />
    );
  } else {
    content = children || value;
  }

  return (
    <SidepanelDefaultRow
      title={enableEdit ? undefined : title}
      valueClassName={`${copyEnabled && enableEdit ? styles.rowWithCopy : ''} ${
        copyEnabled && !enableEdit ? styles.readCopyButtonWrapper : ''
      }`}
    >
      {content}
      {copyEnabled && (
        <>
          {enableEdit && (
            <button
              type="button"
              className={`${styles.copyButton} ${styles.textareaCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
          {!enableEdit && (
            <button
              type="button"
              className={`${styles.readCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
        </>
      )}
    </SidepanelDefaultRow>
  );
}
